import "./footer.css";


export default function Footer() {
    return (
        <div id="footer">
            <div>
                <b>주식회사 오메가포인트</b> | <b>대표이사</b> 이충기, 한정규 | <b>개인정보보호책임자</b> 한정규
            </div>
            <div>
                <b>사업자등록번호</b> 114-86-01317 | <b>통신판매업신고</b> 2009-서울서초-0331
            </div>
            <div>
                <b>전화</b> 02-3446-9660 | <b>팩스</b> 02-3446-9663
            </div>
            <div>
                <b>서울특별시 서초구 강남대로93길 9, 1F-3F (잠원동)</b>
            </div>
            <div>ⓒ 2000 OMEGA POINT INC. ALL RIGHTS RESERVED.</div>
        </div>
    )
}